import { render, staticRenderFns } from "./ProductsBarcodeScanner.vue?vue&type=template&id=c4d4e542&"
import script from "./ProductsBarcodeScanner.vue?vue&type=script&lang=js&"
export * from "./ProductsBarcodeScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports